import styled from 'styled-components'

import { COLORS } from '../../commons/Colors'
import { ROUTES } from '../../commons/utils/AppRoutes'
import TabCard from './TabCard'

const TABS_CONFIG = {
    gdv: [
        {
            title: 'Permissionamentos',
            path: ROUTES.APPPERMISSIONS,
        },
        {
            title: 'Regras comerciais',
            path: ROUTES.COMMERCIALRULES,
        },
        {
            title: 'Busca de Usuário',
            path: ROUTES.USERSEARCH,
        },
        {
            title: 'Busca de Cliente',
            path: ROUTES.CLIENTSEARCH,
        },
        {
            title: 'Feature Flags',
            path: ROUTES.FEATUREFLAGS,
        },
    ],
    mills: [
        {
            title: 'Fábricas',
            path: ROUTES.MILLSLIST,
        },
        {
            title: 'Importação',
            path: ROUTES.IMPORT,
        },
    ],
    commons: [
        {
            title: 'Notificações Gerais',
            path: ROUTES.NEWS,
        },
    ],
}

type MainContentProps = {
    isDsmUser: boolean
}

export default function MainContent({
    isDsmUser,
}: MainContentProps): JSX.Element {
    const tabs = [
        ...(isDsmUser ? TABS_CONFIG.gdv : TABS_CONFIG.mills),
        ...TABS_CONFIG.commons,
    ]
    const title = isDsmUser
        ? 'BEM VINDOS AO PORTAL ADMINISTRATIVO - TIME DSM FIRMENICH'
        : 'BEM VINDOS AO PORTAL ADMINISTRATIVO'

    return (
        <MainContainer>
            <PageTitle>{title}</PageTitle>
            <TabContainer>
                {tabs.map(({ title, path }) => (
                    <TabCard key={title} title={title} path={path} />
                ))}
            </TabContainer>
        </MainContainer>
    )
}

const MainContainer = styled.div`
    background-color: ${COLORS.primaryWhite};
    border: solid 1px ${COLORS.borderGray};
    border-radius: 3px;
    display: flex;
    flex-direction: column;
    margin: 30px;
    padding: 25px 25px 50px 25px;
`

const PageTitle = styled.h1`
    align: center;
    color: ${COLORS.primaryGray};
    font-size: 12px;
    font-family: Roboto;
    font-weight: bold;
    text-align: center;
    margin-bottom: 70px;
`

const TabContainer = styled.div`
    display: flex;
`
